<!--
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-12-21 13:47:23
 * @LastEditTime: 2022-01-21 12:05:37
-->
<template>
  <div class="region-total " :class="{'justify-end':!isjustifyEnd,'flex':isFlex, 'align-center':isFlex}">
    <i :class="'icon'+' '+'icon-flag'+' '+ (countryDetail.icon?(countryDetail.icon +' ' + 'icon-img'):'')" />
    <span v-if="show">{{ orderForm.region==='no'?'(no app)':(abbreviation ? countryDetail.sign : countryDetail.name) }}</span>
  </div>
</template>

<script>
import {reactive,toRefs,watch,onMounted } from 'vue';
import { useStore } from 'vuex'
export default {
  name: 'Region',
  props: {
    region: { type: String, default: '' },
    abbreviation: { type: Boolean, default: false },
    show: { type: Boolean, default: true },
    isjustifyEnd:{
      type: Boolean, default: false
    },
    isFlex:{
      type: Boolean, default: true
    }
  },
  setup(props){
    const data=reactive({
      countryDetail: {
        icon: 'icon-flag-us',
        name: 'American',
        sign: 'US'
      }
    })
    const store=useStore()

    const orderForm = store.state.order.order

    const getRegion=()=>{
      if (props.region&&props.region!=='no') {
        const a = JSON.parse(localStorage.getItem('COUNSTRY')).find(item => item.sign === props.region)
        Object.assign(data.countryDetail, a)
      }else if(props.region==='no'){
        data.countryDetail='(no app)'
      }
    }
    watch(()=>props.region,(newValue)=>{//通过一个函数返回要监听的属性
      getRegion(newValue)
    })
    onMounted(()=>{
      getRegion()
    })
    return {...toRefs(data),getRegion,orderForm}
  }


}
</script>

<style scoped lang="scss">
@import '../SelectCountry/css/counstry.icon.scss';

.region-total {
  justify-content: center;
  font-size: 13px;

  i {
    margin: 0 5px;
  }

  span {
    color: $fontColor;
  }
}
</style>
